// nodes/CharacterNode.ts
import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'

export class CharacterNode extends BaseNode {
    next = NodeType.Parans
    enableSuggestions = true
    suggestionPlacement = 'bottom'

    static getType(): string {
        return 'character'
    }

    static clone(node: CharacterNode): CharacterNode {
        return new CharacterNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(): HTMLElement {
        const dom = document.createElement('div')
        dom.className = 'character node-style-common avoid-page-break'
        return dom
    }

    static importJSON(jsonNode: SerializedBaseNode): CharacterNode {
        return new CharacterNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }
}
